import * as types from '../../lib/actionTypes.es6';
import { take, call, put } from 'redux-saga/effects';
import { getEngineFlows, getEngineFlowRaw, publishEngineFlow, createEngineFlow } from '../../lib/requests.es6';
import * as actions from './actions.es6';
import { unAuthorizedNotification } from '../../lib/access.es6';
import { GAloggerException } from '../../lib/monitoring.es6';

export function* getEngineFlowsWatcher() {
  while (true) {
    const { payload: partner } = yield take(types.GET_ENGINE_FLOWS_REQUEST);
    try {
      const response = yield call(getEngineFlows, partner);
      yield put(actions.getEngineFlowsSuccess(response.data));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getEngineFlowsFail(e.response ? e.response.data : {}));
    }
  }
}

export function* getEngineFlowRawWatcher() {
  while (true) {
    const { payload: { partner, flowId } } = yield take(types.GET_ENGINE_FLOW_RAW_REQUEST);
    try {
      const response = yield call(getEngineFlowRaw, partner, flowId);
      yield put(actions.getEngineFlowRawSuccess(response.data.yaml));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.getEngineFlowRawFail(e.response ? e.response.data : {}));
    }
  }
}

export function* publishEngineFlowWatcher() {
  while (true) {
    const { payload: { partner, flowId, rawYaml } } = yield take(types.PUBLISH_ENGINE_FLOW_REQUEST);
    try {
      const response = yield call(publishEngineFlow, partner, flowId, rawYaml);
      yield put(actions.publishEngineFlowSuccess(response.data));
      yield put(actions.getEngineFlowsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.publishEngineFlowFail(e.response ? e.response.data : {}));
    }
  }
}

export function* createEngineFlowWatcher() {
  while (true) {
    const { payload: { partner, rawYaml } } = yield take(types.CREATE_ENGINE_FLOW_REQUEST);
    try {
      const response = yield call(createEngineFlow, partner, rawYaml);
      yield put(actions.createEngineFlowSuccess(response.data));
      yield put(actions.getEngineFlowsRequest(partner));
    } catch (e) {
      if (e.response) unAuthorizedNotification(e);
      GAloggerException(e);
      yield put(actions.createEngineFlowFail(e.response ? e.response.data : {}));
    }
  }
}
